import { render, staticRenderFns } from "./add-logistics.vue?vue&type=template&id=c9731d20"
import script from "./add-logistics.vue?vue&type=script&lang=ts"
export * from "./add-logistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports